import { Avatar, Box, Button, Chip, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, MenuItem, Paper, Step, StepConnector, StepLabel, Stepper, Typography, styled } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'

import moment from 'moment';
import { domToPng } from 'modern-screenshot';
import CircleIcon from "@mui/icons-material/Circle";
import { deepPurple } from '@mui/material/colors';

import { ContextMenuTrigger } from 'react-contextmenu';
import { PDFExport } from '@progress/kendo-react-pdf';
import Colors from '../Colors';
import Images from '../../../assets/images';
import OrderServices from '../../../api/orderServices/order.index';
import SimpleDialog from '../../../components/Dialog';
import { useForm } from 'react-hook-form';
import { ErrorToaster, SuccessToaster } from '../../../components/Toaster';
import { ErrorHandler } from '../../../utils/ErrorHandler';
import SelectField from '../../../components/SelectField';
import { currencyType2 } from '../../../utils';
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1.5),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
const useStyles = styled({
    blurredBackground: {
        filter: 'blur(12px)', // Apply the blur effect
        transition: 'filter 0.3s ease', // Smooth transition
    },
    popupImage: {
        width: '100%',
        maxWidth: '300px',
        margin: '0 auto',
    },
    popupButton: {
        backgroundColor: '#00a8ff', // Same button color
        color: '#fff',
        marginTop: '20px',
    },
});

const steps = ['Pending', 'Processing', 'Confirmed', 'Delivered'];

const ColorConnector = styled(StepConnector)(({ theme }) => ({
    [`& .${StepConnector.line}`]: {
        borderColor: theme.palette.primary.main,
    },
}));

const ColorStepLabel = styled(StepLabel)(({ theme, active, completed }) => ({
    '& .MuiStepLabel-label': {
        color: active || completed ? ` ${Colors.secondary} !important  ` : '#a1acb1',
    },
    '& .MuiStepIcon-root': {
        color: active || completed ? theme.palette.primary.main : 'white',
    },
}));
const OrderDetail = () => {
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm();
    const classes = useStyles();
    const { state } = useLocation()
    const [rotateDirection, setRotateDirection] = useState(false)
    console.log(state);
    const [tshirtPrice, setTshirtPrice] = useState(0)
    console.log(state);
    const [open, setOpen] = useState(false);
    const [allData, setAllData] = useState(null)
    const pdfExportComponentFront = useRef(null);
    const pdfExportComponentBack = useRef(null);
    const elementFront = useRef(null)
    const elementBack = useRef(null)
    const parentRef = useRef(null);
    const divRef = useRef(null);
    const divRefBack = useRef(null);
    const [checked, setChecked] = React.useState(false);
    const [loader, setLoader] = useState(false)
    const [selectedSize, setSelectedSize] = useState()
    const [openDialog, setOpenDialog] = useState(false)
    const [selectedOrder, setSelectedOrder] = useState(state)
    const [selectedStatus, setSelectedStatus] = useState(null)
    const [orderData, setOrderData] = useState(null)

    const getOrderDetail = async () => {

        let obj = {
            order_id: state?._id
        }
        try {
            const { data, responseCode, message } = await OrderServices.getOrderDetail(obj);
            console.log(data);
            setOrderData(data?.orders)


        } catch (error) {
            console.error("Error while fetching users:", error);
        }
    };
    const updateStatus = async (formData) => {
        let obj = {
            order_id: selectedOrder?._id,
            status: selectedStatus?.id,
        };
        console.log(obj);
        try {
            const data = await OrderServices.updateStatus(obj);

            SuccessToaster(data.message);
            setOpenDialog(false);
            setSelectedStatus(null)
            getOrderDetail()
            //   handleGetOrders();
        } catch (error) {
            ErrorHandler(error);
            ErrorToaster(error?.message);
        }
    };
    useEffect(() => {
        getOrderDetail()
    }, [])

    const waitForImagesToLoad = () => {
        return new Promise((resolve) => {
            const imgElements = document.querySelectorAll('img'); // Update this selector as per your needs

            let loadedCount = 0;

            imgElements.forEach((img) => {
                if (img.complete) {
                    loadedCount++;
                } else {
                    img.onload = () => {
                        loadedCount++;
                        if (loadedCount === imgElements.length) {
                            resolve();
                        }
                    };
                }
            });

            if (loadedCount === imgElements.length) {

                resolve();
            }
        });
    };

    async function handleBase64ImageUpload(base64String, direction) {
        if (base64String) {
            const img = new Image();
            img.onload = function () {
                // uploadedImage = img
                // displayImagePreview(img);
            };
            img.src = base64String;
            console.log(base64String, 'uploadedImageuploadedImageuploadedImage');

            console.log(img, 'uploadedImageuploadedImageuploadedImage');

            await downloadImage(img, direction)
            console.log(base64String, 'uploadedImage');



        }
    }




    async function downloadImage(uploadedImage, direction) {
        console.log(uploadedImage, 'sadasasdas');

        if (!uploadedImage) {
            alert("Please upload an image first.");
            return;
        }

        // Create an offscreen canvas
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // A4 size at 300 DPI: 8.27 x 300 px (width), 11.69 x 300 px (height)
        let a4Width
        let a4Height


        // Resize the uploaded image to fit the required size with the aspect ratio
        let scaleFactor  // Scale based on 4.17 inches width at 300 DPI


        if (selectedSize.toLowerCase() == 'small') {

            a4Width = 8.27 * 300;  // 8.27 inches at 300 DPI (width)
            a4Height = 11.69 * 300;  // 11.69 inches at 300 DPI (height)
            scaleFactor = 5.79 * 300 / uploadedImage.width;
        }
        else if (selectedSize.toLowerCase() == 'medium') {
            a4Width = 8.27 * 300;  // 8.27 inches at 300 DPI (width)
            a4Height = 11.69 * 300;  // 11.69 inches at 300 DPI (height)
            scaleFactor = 8.27 * 300 / uploadedImage.width;
        }
        else if (selectedSize.toLowerCase() == 'large') {
            a4Width = 11.69 * 300;  // 11.69 inches at 300 DPI (width)
            a4Height = 16.54 * 300; // 16.54 inches at 300 DPI (height)
            scaleFactor = 8.18 * 300 / uploadedImage.width;
        }
        else {
            a4Width = 11.69 * 300;  // 11.69 inches at 300 DPI (width)
            a4Height = 16.54 * 300; // 16.54 inches at 300 DPI (height)
            scaleFactor = 11.69 * 300 / uploadedImage.width;
        }
        // Set canvas to A4 size (300 DPI)
        canvas.width = a4Width;
        canvas.height = a4Height;
        const resizedWidth = uploadedImage.width * scaleFactor;
        const resizedHeight = uploadedImage.height * scaleFactor;
        // Calculate positioning with 2 inches padding from top and left
        const paddingLeft = 0.2 * 300;  // 2 inches to pixels at 300 DPI
        const paddingTop = 0.2 * 300;   // 2 inches to pixels at 300 DPI

        // Clear the canvas and draw the resized image
        ctx.clearRect(0, 0, canvas.width, canvas.height);  // Clear canvas before drawing
        console.log(uploadedImage, 'sadasasdas12');


        await ctx.drawImage(uploadedImage, paddingLeft, paddingTop, resizedWidth, resizedHeight);

        console.log(uploadedImage, 'sadasasdas123');

        // Convert the canvas content to a data URL (PNG)
        const dataURL = canvas.toDataURL("image/png");

        // Create a download link and trigger the download
        const a = document.createElement("a");
        a.href = dataURL;
        console.log(dataURL, "sadasasdas1234");
        //   const url = await Base64Update(dataURL, 'front.png'); // Await Base64Update
        //   console.log(url);

        //   window.location.href = url; // Redirect to the updated URL
        //   downloadImage()
        a.download = `${state?.order_no}-${selectedSize}-${direction}-Design`;
        a.click();
    }

    const capture = async () => {
        setLoader(true)
        try {
            const div = divRef.current;
            if (!div) {

                return;
            }

            await waitForImagesToLoad(div); // Ensure images are loaded

            const a4Width = 220; // mm
            const a4Height = 317; // mm
            const scale = 10; // Adjust for image resolution

            // Set div styles to match A4 size
            div.style.width = `${a4Width}mm`;
            div.style.height = `${a4Height}mm`;
            div.style.padding = '0';
            div.style.border = 'none';
            div.style.overflow = 'hidden';


            // Capture the screenshot
            const dataUrl = await domToPng(div, {
                bgcolor: 'transparent',
                width: a4Width * scale,
                height: a4Height * scale,
                useCORS: true,
                style: {
                    transform: `scale(${scale})`,
                    transformOrigin: 'top left',
                },
            });
            console.log(dataUrl, 'dataUrldataUrl');
            handleBase64ImageUpload(dataUrl, 'Front')


        } catch (error) {

            setLoader(false)
        }
        finally {
            setLoader(false)
        }
    };


    const captureBack = async () => {
        setLoader(true)
        try {
            const div = divRefBack.current;
            if (!div) {

                return;
            }

            await waitForImagesToLoad(div); // Ensure images are loaded

            const a4Width = 220; // mm
            const a4Height = 317; // mm
            const scale = 10; // Adjust for image resolution

            // Set div styles to match A4 size
            div.style.width = `${a4Width}mm`;
            div.style.height = `${a4Height}mm`;
            div.style.padding = '0';
            div.style.border = 'none';
            div.style.overflow = 'hidden';



            // Capture the screenshot
            const dataUrl = await domToPng(div, {
                bgcolor: 'transparent',
                width: a4Width * scale,
                height: a4Height * scale,
                useCORS: true,
                style: {
                    transform: `scale(${scale})`,
                    transformOrigin: 'top left',
                },
            });


            console.log(dataUrl, 'dataUrldataUrl');
            handleBase64ImageUpload(dataUrl, 'Back')

        } catch (error) {
            setLoader(false)
        }
        finally {
            setLoader(false)
        }
    };
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const getPricing = async () => {
        try {
            let params = {

            }
            const { data } = await OrderServices.getPricing(params)
            console.log(data);
            setTshirtPrice(data?.pricing?.standard_price)


        } catch (error) {
            console.log(error);
        } finally {

        }
    }
    const [status, setStatus] = useState(1)
    useEffect(() => {
        if (state) {
            const index = steps.findIndex(step => step.toLowerCase() === state?.status?.toLowerCase());
            console.log(index);
            setStatus(index)
        }
        getPricing()
    }, [])

    return (
        <div style={{ background: "#0F172A" }} >
            <Dialog
                PaperProps={{
                    sx: {
                        backgroundColor: "#1a2537", // Set dialog background to black
                        color: "white", // Make sure text stays visible
                        borderRadius: 3,
                        width: '400px',

                    },
                }}


                open={openDialog}
                onClose={() => {
                    setOpenDialog(false);
                }}
                title="Update Status"
                selectedUser={selectedOrder}
            >
                <DialogTitle sx={{ textAlign: 'center' }} id="confirm-dialog-title">Update Status</DialogTitle>
                <Box component={"form"} onSubmit={handleSubmit(updateStatus)}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} m={2}>
                            <SelectField
                                size="small"
                                label={"Select Status"}
                                multiple
                                options={[
                                    { id: "pending", name: "Pending" },
                                    { id: "processing", name: "Processing" },
                                        { id: "On The Way", name: "On The Way" },
                                    { id: "delivered", name: "Delivered" },
                                    { id: "rejected", name: "Rejected" },
                                ]}
                                selected={selectedStatus}
                                onSelect={(value) => setSelectedStatus(value)}
                                error={errors?.status?.message}
                                register3={register("status", {
                                    required: selectedStatus ? false : "status is required",
                                })}
                            />
                        </Grid>

                        {/* Submit Button */}
                        <Grid item xs={12} sm={12} display={'flex'} mb={3} justifyContent={'center'}>

                            <Button
                                type="submit"
                                variant="contained"

                                sx={{
                                    background: "#00BCD4",
                                    color: "white",
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: 4,
                                    textTransform: "none",
                                    color: '#101A33',
                                    fontSize: "16px",
                                    fontWeight: 700,
                                    "&:hover": {
                                        background: "#00ACC1",
                                    },
                                }}

                            >
                                Update
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Dialog>
            <Dialog
                slotProps={{
                    backdrop: {
                        sx: {
                            backdropFilter: "blur(8px)",
                            backgroundColor: "transparent",
                        }

                    },


                }}
                PaperProps={{
                    sx: {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        borderRadius: '12px'
                    }
                }} maxWidth={'lg'} sx={{ borderRadius: '12px' }} open={open} onClose={handleClose}>

                <DialogContent className={classes.blurredBackground} sx={{ backgroundColor: '#0F172A', overflow: 'hidden' }}>
                    <Grid container justifyContent={'space-around'}>

                        <Button onClick={() => {
                            if (!loader) {
                                capture()
                            }
                        }} sx={{ textTransform: 'capitalize', border: '1px solid #0EA5EA', width: '180px', height: "40px" }}>{loader ? <CircularProgress size={15} /> : 'Download Front Design'}</Button>
                        <Button onClick={() => {
                            if (!loader) {
                                captureBack()
                            }
                        }} sx={{ textTransform: 'capitalize', border: '1px solid #0EA5EA', width: '180px', height: "40px" }}>{loader ? <CircularProgress size={15} /> : 'Download Back Design'}</Button>
                    </Grid>
                    <Grid container >

                        {allData && <Grid component={'div'} className={`  tshirt-img-scale2`} ref={elementFront} item lg={6} md={12} sx={{ display: 'flex', justifyContent: 'center', height: '570px !important', position: 'relative' }}>
                            <div style={{ position: 'relative' }}>

                                <img width={'500px'} height={'570px'} id="tshirt-backgroundpicture" src={Images[allData?.color ? allData?.color : 'white']} />
                                <div style={{ position: 'absolute', top: 90, left: 145, backgroundColor: 'rgba(0,0,0,0)' }}>
                                    {!rotateDirection && <PDFExport ref={pdfExportComponentFront} paperSize="A4" scale={2.7} fileName="Frontprint">
                                        <div ref={divRef} style={{ backgroundColor: 'transparent' }} id='pdfFront'>
                                            <div className=' pdf-data' ref={parentRef} style={{ width: '220px', height: '313px', position: 'relative', overflow: 'hidden' }}>

                                                {allData?.frontText && allData.frontText.length > 0 && allData.frontText.map((item, index) => {
                                                    console.log(item?.fontSize, 'dedede');
                                                    const textStyle = {
                                                        fontSize: item?.fontSize?.toString().includes('px') ? item.fontSize : `${item.fontSize}px`,
                                                        fontWeight: item.fontWeight,
                                                        fill: item.color,
                                                        fontFamily: item.fontFamily,

                                                    };

                                                    const circlePath = `M ${item.width / 2}, ${item.width / 2} m -${item.width / 3}, 0 a ${item.width / 3},${item.width / 3} 0 1,1 ${2 * (item.width / 3)},0 a ${item.width / 3},${item.width / 3} 0 1,1 -${2 * (item.width / 3)},0`;
                                                    const ellipsePath = `M ${item.width / 2}, ${item.width / 2} m -${item.width / 3}, 0 a ${item.width / 3},${item.width / 6} 0 1,1 ${2 * (item.width / 3)},0 a ${item.width / 3},${item.width / 6} 0 1,1 -${2 * (item.width / 3)},0`;
                                                    const wavePath = `M 10, ${item.width / 2} Q ${item.width / 5}, ${item.width / 5} ${2 * (item.width / 5)}, ${item.width / 2} T ${4 * (item.width / 5)}, ${item.width / 2} T ${item.width - 10}, ${item.width / 2}`;
                                                    const straightPath = `M 0,${item.width / 2} L ${item.width},${item.width / 2}`;

                                                    const shapePaths = {
                                                        circlePath,
                                                        ellipsePath,
                                                        wavePath,
                                                        straightPath,
                                                    };

                                                    const selectedPath = shapePaths[item.shape] || '';
                                                    const uniqueId = `front-circlePath${index}`;

                                                    return (
                                                        <React.Fragment key={index}>
                                                            <div
                                                                id={index}
                                                                style={{
                                                                    position: 'absolute',
                                                                    width: `${item.width}px`,
                                                                    height: `${item.height}px`,
                                                                    top: item?.top?.toString().includes('px') ? item.top : `${item.top}px`,
                                                                    left: item?.left?.toString().includes('px') ? item.left : `${item.left}px`,
                                                                    transform: `rotate(${item.rotation}deg)`,
                                                                    zIndex: item.zIndexes,
                                                                    backgroundImage: `url('${item.url}')`,
                                                                    backgroundSize: 'contain',
                                                                    backgroundRepeat: 'no-repeat',
                                                                    backgroundPosition: 'center'
                                                                }}
                                                            >


                                                            </div>
                                                        </React.Fragment>
                                                    );
                                                })}


                                                {allData?.frontPic.length > 0 && allData?.frontPic.map((imageData, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <Grid
                                                                component={'div'}
                                                                className={`Design-${index}`}
                                                                style={{
                                                                    clipPath: imageData.clipPath,
                                                                    width: `${imageData.width}px`,
                                                                    height: `${imageData.height}px`,
                                                                    position: 'absolute',
                                                                    backgroundImage: `url(https://corsproxy.io/?url=${imageData.imageUrl})`,
                                                                    backgroundSize: 'contain',
                                                                    backgroundPosition: 'center',
                                                                    backgroundRepeat: 'no-repeat',
                                                                    top: `${imageData.top}px`,
                                                                    left: `${imageData.left}px`,
                                                                    borderRadius: `${imageData.borderRadius}px`,
                                                                    transform: `${imageData.rotation}`,
                                                                    zIndex: imageData?.zIndexes,
                                                                }}
                                                                onError={(e) => {
                                                                    // Fallback to direct image URL if the proxy fails
                                                                    e.target.style.backgroundImage = `url(${imageData.imageUrl})`;
                                                                }}
                                                            />
                                                            {/* Add overlay image */}
                                                            {checked && <Grid
                                                                component={'div'}
                                                                className={`Overlay-${index}`}
                                                                style={{
                                                                    width: `${imageData.width}px`,
                                                                    height: `${imageData.height}px`,
                                                                    position: 'absolute',
                                                                    top: `${imageData.top}px`,
                                                                    left: `${imageData.left}px`,
                                                                    backgroundImage: `url(${allData?.color == 'white' ? Images?.toneWhite : allData?.color == 'black' ? Images?.toneBlack : allData?.color == 'lightgreen' ? Images?.toneGreen : allData?.color == 'darkgreen' ? Images?.toneDarkGreen : allData?.color == 'blue' ? Images?.toneBlue : allData?.color == 'yellow' ? Images?.toneOrange : allData?.color == 'purple' ? Images?.tonePurple : 'white'})`, // Path to the overlay image
                                                                    backgroundSize: 'contain',
                                                                    backgroundPosition: 'center',
                                                                    backgroundRepeat: 'no-repeat',
                                                                    opacity: 0.5, // Adjust the transparency of the overlay image
                                                                    zIndex: imageData?.zIndexes + 1 // Place overlay above the image
                                                                }}
                                                            />}
                                                        </div>
                                                    );
                                                })}


                                            </div>
                                        </div>
                                    </PDFExport>}

                                </div>
                            </div></Grid>}

                        {allData && <Grid item lg={6} md={12} className={`  tshirt-img-scale2`} ref={elementBack} sx={{ display: 'flex', justifyContent: 'center', height: '570px !important' }}> <div style={{ position: 'relative' }}>
                            <img width={'500px'} height={'570px'} id="tshirt-backgroundpicture" src={Images[allData?.color ? allData?.color + "Back" : 'white' + "Back"]} />
                            <div style={{ position: 'absolute', top: 90, left: 145 }}>

                                <PDFExport ref={pdfExportComponentBack} paperSize="A4" scale={2.7} fileName="Backprint">
                                    <div ref={divRefBack} style={{ backgroundColor: 'transparent' }} id='pdfBack'>
                                        <div className='pdf-data' ref={parentRef} style={{ width: '220px', height: '313px', position: 'relative', overflow: 'hidden' }}>

                                            {allData?.backText && allData?.backText.length > 0 && allData.backText.map((item, index) => {
                                                const textStyle = {

                                                    fontSize: item?.fontSize?.toString().includes('px') ? item.fontSize : `${item.fontSize}px`,
                                                    fontWeight: item.fontWeight,
                                                    fill: item.color,
                                                    fontFamily: item.fontFamily,

                                                };
                                                const circlePath = `M ${item.width / 2}, ${item.width / 2} m -${item.width / 3}, 0 a ${item.width / 3},${item.width / 3} 0 1,1 ${2 * (item.width / 3)},0 a ${item.width / 3},${item.width / 3} 0 1,1 -${2 * (item.width / 3)},0`;
                                                const ellipsePath = `M ${item.width / 2}, ${item.width / 2} m -${item.width / 3}, 0 a ${item.width / 3},${item.width / 6} 0 1,1 ${2 * (item.width / 3)},0 a ${item.width / 3},${item.width / 6} 0 1,1 -${item.width / 3},0`;
                                                const wavePath = `M 10, ${item.width / 2} Q ${item.width / 5}, ${item.width / 5} ${2 * (item.width / 5)}, ${item.width / 2} T ${4 * (item.width / 5)}, ${item.width / 2} T ${item.width - 10}, ${item.width / 2}`;
                                                const straightPath = `M 0,${item.width / 2} L ${item.width},${item.width / 2}`;

                                                const shapePaths = {
                                                    circlePath,
                                                    ellipsePath,
                                                    wavePath,
                                                    straightPath,
                                                };

                                                const selectedPath = shapePaths[item.shape] || '';
                                                const uniqueId = `back-circlePath${index}`;

                                                return (
                                                    <React.Fragment key={index}>

                                                        <div
                                                            id={`back${index}`}
                                                            style={{
                                                                position: 'absolute',
                                                                width: `${item.width}px`,
                                                                height: `${item.height}px`,
                                                                top: item?.top?.toString().includes('px') ? item.top : `${item.top}px`,
                                                                left: item?.left?.toString().includes('px') ? item.left : `${item.left}px`,
                                                                transform: `rotate(${item.rotation}deg)`,
                                                                zIndex: item.zIndexes,
                                                                backgroundImage: `url('${item.url}')`,
                                                                backgroundSize: 'contain',
                                                                backgroundRepeat: 'no-repeat',
                                                                backgroundPosition: 'center'
                                                            }}>

                                                        </div>

                                                    </React.Fragment>
                                                );
                                            })}

                                            {allData?.backPic.length > 0 && allData?.backPic.map((imageUrl, index) => (
                                                <div key={index}>
                                                    <Grid
                                                        component={'div'}
                                                        className={`Design2-${index}`}
                                                        style={{
                                                            clipPath: allData?.backPic[index].clipPath,
                                                            width: `${allData?.backPic[index].width}px`,
                                                            height: `${allData?.backPic[index].height}px`,
                                                            position: 'absolute',
                                                            backgroundImage: `url(https://corsproxy.io/?url=${imageUrl?.imageUrl}), url(${imageUrl?.imageUrl})`,
                                                            backgroundSize: 'contain',
                                                            backgroundPosition: 'center',
                                                            backgroundRepeat: 'no-repeat',
                                                            top: `${allData?.backPic[index].top}px`,
                                                            left: `${allData?.backPic[index].left}px`,
                                                            borderRadius: `${allData?.backPic[index].borderRadius}px`,
                                                            transform: `${allData?.backPic[index].rotation}`,
                                                            zIndex: imageUrl?.zIndexes,
                                                        }}
                                                        onError={(e) => {
                                                            // Handle image fallback if the proxy fails
                                                            e.target.style.backgroundImage = `url(${imageUrl?.imageUrl})`;
                                                        }}
                                                    />
                                                    {false && <Grid
                                                        component={'div'}
                                                        className={`Overlay2-${index}`}
                                                        style={{
                                                            width: `${imageUrl.width}px`,
                                                            height: `${imageUrl.height}px`,
                                                            position: 'absolute',
                                                            top: `${imageUrl.top}px`,
                                                            left: `${imageUrl.left}px`,
                                                            backgroundImage: `url(${allData?.color == 'white' ? Images?.toneWhite : allData?.color == 'black' ? Images?.toneBlack : allData?.color == 'lightgreen' ? Images?.toneGreen : allData?.color == 'darkgreen' ? Images?.toneDarkGreen : allData?.color == 'blue' ? Images?.toneBlue : allData?.color == 'yellow' ? Images?.toneOrange : allData?.color == 'purple' ? Images?.tonePurple : 'white'})`, // Path to the overlay image
                                                            backgroundSize: 'contain',
                                                            backgroundPosition: 'center',
                                                            backgroundRepeat: 'no-repeat',
                                                            opacity: 0.5, // Adjust the transparency of the overlay image
                                                            zIndex: imageUrl?.zIndexes + 1 // Place overlay above the image
                                                        }}
                                                    />}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </PDFExport>
                            </div>
                        </div></Grid>}
                    </Grid>
                </DialogContent>

            </Dialog>
            <Box
                sx={{
                    backgroundImage: `url("${Images.contactBg}")`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    width: "100%",
                    height: { lg: "170px", md: "170px", sm: "170px", xs: "170px" },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1.5 }}>
                    <Typography
                        className="banner-text heading-font"
                        sx={{
                            fontSize: { lg: "52px", md: "52px", sm: "52px", xs: "30px" },
                            textAlign: "center",
                            fontFamily: "Maven Pro, sans-serif !important",
                            color: "white",
                        }}
                    >
                        Order Detail
                    </Typography>
                </Box>
            </Box>
            <Container maxWidth={'lg'} sx={{ mt: 4 }} >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Box>
                        <Box sx={{ color: '#7F92B0', fontSize: '16px' }}>Order ID</Box>
                        <Box component={'div'} className='heading-font' sx={{ fontWeight: 700, fontSize: '24px', color: 'white' }}>{state?.order_no}</Box>
                    </Box>
                    <Box>
                        <Button
                            variant="outlined"
                            onClick={() => setOpenDialog(true)}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                padding: "5px 0px",
                                width: "200px",
                                borderRadius: "8px",
                                textTransform: "none",
                                fontSize: "16px",
                                fontWeight: "bold",
                                backgroundColor: orderData?.status == 'delivered' ? "#143D39" : '#5A4A1E', // Dark green background
                                border: orderData?.status == 'delivered' ? "2px solid #3FBF43" : "2px solid #D4AF37", // Green border
                                color: "#FFFFFF",
                                ":hover": {
                                    backgroundColor: orderData?.status == 'delivered' ? "#143D39" : '#5A4A1E', // Dark green background
                                    border: orderData?.status == 'delivered' ? "2px solid #3FBF43" : "2px solid #D4AF37", // Green border
                                    color: "#FFFFFF",

                                }

                            }}
                        >
                            <CircleIcon sx={{ fontSize: 12, color: "white" }} />
                            <Typography sx={{ textTransform: 'capitalize' }}>{orderData?.status}</Typography>
                        </Button>
                    </Box>
                </Box>
                <Grid container columnGap={7}>
                    <Grid item lg={5.7} xs={12} p={3} mt={4} sx={{ cursor: 'pointer', backgroundColor: '#1b2335', borderRadius: "15px" }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '96%' }}>

                            <Box component={'div'} className='heading-font2' sx={{ fontWeight: 400, color: 'white !important' }}>Order Details</Box>

                        </Box>
                        {console.log(state)}
                        <Divider style={{ width: '100%', borderColor: '#B0B0B04D', marginTop: '20px' }} />
                        <Grid container sx={{ mb: 2, mt: 2 }} alignItems="center" spacing={1}>
                            <Grid item xs={6} sm={4}>
                                <Box sx={{ color: 'gray', fontWeight: 600, fontSize: '14px' }}>
                                    Vendor Name :
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <Box
                                    sx={{
                                        color: 'white',
                                        fontWeight: 600,
                                        fontSize: '12px',
                                        textAlign: 'left',
                                    }}
                                >
                                    {state?.vendor?.name}
                                </Box>
                            </Grid>
                            {[
                                { label: 'Total Designs', value: state?.designs?.length },
                                { label: 'Total Quantity', value: state?.total_qty },
                                // { label: 'Total Pricing', value: state?.total_amount },
                                // { label: 'Payment Method', value: 'Card' },
                                { label: 'Promo Code', value: state?.promo_code || '-' },
                                { label: 'Placed At', value: moment(state?.date).format('DD-MM-YYYY') },
                            ].map((item, index) => (
                                <React.Fragment key={index}>
                                    <Grid item xs={6} sm={4}>
                                        <Box sx={{ color: 'gray', fontWeight: 600, fontSize: '14px' }}>
                                            {item.label} :
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6} sm={2}>
                                        <Box
                                            sx={{
                                                color: 'white',
                                                fontWeight: 600,
                                                fontSize: '12px',
                                                textAlign: 'left',
                                            }}
                                        >
                                            {item.value}
                                        </Box>
                                    </Grid>
                                </React.Fragment>
                            ))}

                        </Grid>



                    </Grid>
                    <Grid
                        item
                        lg={5.7}
                        xs={12}
                        p={3}
                        mt={4}
                        sx={{
                            cursor: 'pointer',
                            backgroundColor: '#1b2335',
                            borderRadius: '15px',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '96%',
                            }}
                        >
                            <Box
                                component="div"
                                className="heading-font2"
                                sx={{
                                    fontWeight: 400,
                                    color: 'white !important',
                                    fontSize: { xs: '14px', sm: '16px', md: '18px' },
                                }}
                            >
                                User Details
                            </Box>
                        </Box>

                        <Divider
                            style={{
                                width: '100%',
                                borderColor: '#B0B0B04D',
                                marginTop: '20px',
                            }}
                        />

                        <Grid container sx={{ mb: 2, mt: 2 }} alignItems="center" spacing={1}>
                            {[
                                { label: 'Name', value: orderData?.customer?.name || '-' },
                                { label: 'Phone', value: orderData?.customer?.phone || '-' },
                                { label: 'Address 1', value: orderData?.address?.address_1 || '-' },
                                { label: 'Address 2', value: orderData?.address?.address_2 || '-' },
                                { label: 'State', value: orderData?.address?.state || '-' },
                                { label: 'City', value: orderData?.address?.city || '-' },
                            ].map((item, index) => (
                                <React.Fragment key={index}>
                                    <Grid item xs={6} sm={3}>
                                        <Box
                                            sx={{
                                                color: 'gray',
                                                fontWeight: 600,
                                                fontSize: '14px',
                                            }}
                                        >
                                            {item.label} :
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <Box
                                            sx={{
                                                color: 'white',
                                                fontWeight: 600,
                                                fontSize: '14px',
                                                textAlign: 'left',
                                            }}
                                        >
                                            {item.value}
                                        </Box>
                                    </Grid>
                                </React.Fragment>
                            ))}
                        </Grid>
                    </Grid>


                    <Grid container mt={4}>
                        <Box component={'div'} className='heading-font' sx={{ fontWeight: 700, fontSize: '24px', color: 'white' }}>Items</Box>
                    </Grid>
                    <Grid container gap={2}>
                        <Grid sx={{ mt: 2 }} container gap={2}>
                            {orderData?.details?.length > 0 ? (
                                orderData?.details.map((item, index) => (

                                    <Grid
                                        item
                                        lg={5.7}
                                        md={5.7}
                                        sm={5.7}
                                        xs={12}
                                        display="flex"
                                        justifyContent="space-around"
                                        alignItems="center"
                                        columnGap={2}

                                        p={2}
                                        sx={{ backgroundColor: '#1b2335', borderRadius: "15px" }}
                                    >
                                        <Box
                                            sx={{
                                                position: 'relative',
                                                width: '100px',
                                                height: 'auto',
                                                '&:hover .overlay': {
                                                    opacity: 1,
                                                },
                                            }}
                                        >
                                            <Box
                                                sx={{

                                                    backgroundColor: '#0BD1D14D',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <Box
                                                    component="img"
                                                    className='no-action'
                                                    src={item.generated_art} // Use item property correctly
                                                    alt="Item"
                                                    sx={{
                                                        width: '100px',
                                                        height: '100px',
                                                        borderRadius: 1,
                                                    }}
                                                />
                                            </Box>
                                            <Box
                                                className="overlay"
                                                component={'div'}
                                                sx={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',  // semi-transparent overlay
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    opacity: 0,
                                                    transition: 'opacity 0.3s ease',
                                                    borderRadius: 1,
                                                    color: 'white',
                                                    cursor: 'pointer'
                                                }}

                                                onClick={() => { setOpen(true); setAllData(state?.designs[item?.design_index]); setSelectedSize(item?.size) }}
                                            >
                                                <Button

                                                    sx={{ color: 'white', textTransform: 'none' }}
                                                >
                                                    Preview
                                                </Button>
                                            </Box>
                                        </Box>

                                        {/* Item Details */}
                                        <Box>
                                            <Typography variant="body2" sx={{ color: 'gray', fontWeight: 600, mt: 1 }}>
                                                Age Group : <span style={{ color: 'white' }}>{item.size_type || 'N/A'}</span>
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: 'gray', fontWeight: 600, mt: 1 }}>
                                                Size : <span style={{ color: 'white' }}>{item.size || 'N/A'}</span>
                                            </Typography>
                                            {/* <Typography variant="body2" sx={{ color: 'gray', fontWeight: 600, mt: 1 }}>
                                                Shirt Quality : <span style={{ color: 'white', textTransform: 'capitalize' }}>{item.shirt_type || 'N/A'}</span>
                                            </Typography> */}
                                            <Typography variant="body2" sx={{ color: 'gray', fontWeight: 600, mt: 1 }}>
                                                Print Fabric : <span style={{ color: 'white', textTransform: 'capitalize' }}>{item.fabric || 'Cotton'}</span>
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: 'gray', fontWeight: 600, mt: 1 }}>
                                                Quantity : <span style={{ color: 'white', textTransform: 'capitalize' }}>{item.qty || 'N/A'}</span>
                                            </Typography>
                                        </Box>
                                    </Grid>

                                ))
                            ) : (
                                <Typography sx={{ color: 'white', textAlign: 'center' }}>
                                    Your cart is empty.
                                </Typography>
                            )}

                        </Grid>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item lg={5.7} sm={12} md={12} xs={12} sx={{ borderRadius: '12px', mt: 10 }}>
                        <Box >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography className='heading-font' variant="h6" mt={0.5} gutterBottom>
                                    Order <Box className='heading-font' component={"span"}> Summary</Box>
                                </Typography>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography className="heading-font" variant="h6" mt={0.5} gutterBottom>
                                        Shipping Type:
                                    </Typography>

                                    <Chip
                                        label={state?.shipping_type} // <-- Replace this with your dynamic shipping type
                                        color="primary" // Options: primary, secondary, success, error, etc.
                                        variant="outlined" // Or "filled"
                                        sx={{ fontWeight: "bold", fontSize: "0.85rem", textTransform: 'capitalize' }}
                                    />
                                </Box>

                            </Box>
                            <div style={{ color: '#fff' }}>

                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '15px', fontFamily: 'Poppins, sans-serif' }}>
                                    <span style={{ color: 'gray' }}>Items ({state?.total_qty})</span>
                                    <span>{currencyType2[state?.vendor?.country]?.code} {state?.sub_amount}</span>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', fontFamily: 'Poppins, sans-serif' }}>
                                    <span style={{ color: 'gray' }}>Shipping :</span>
                                    <span>{currencyType2[state?.vendor?.country]?.code} {state?.delivery_charges}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', fontFamily: 'Poppins, sans-serif' }}>
                                    <span style={{ color: 'gray' }}>Discount :</span>
                                    <span>{currencyType2[state?.vendor?.country]?.code} {state?.promo_discount}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', fontFamily: 'Poppins, sans-serif' }}>
                                    <span style={{ color: 'gray' }}>Sub Total :</span>
                                    <span>{currencyType2[state?.vendor?.country]?.code} {parseFloat(parseFloat(state?.sub_amount) + parseFloat(state?.delivery_charges)) - parseFloat(state?.promo_discount)}</span>
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        marginTop: '10px',
                                        fontFamily: 'Poppins, sans-serif'
                                    }}
                                >
                                    <span style={{ color: 'gray' }}>GST 18% :</span>
                                    <span>
                                        {(() => {
                                            const subtotal =
                                                parseFloat(state?.sub_amount || 0) +
                                                parseFloat(state?.delivery_charges || 0) -
                                                parseFloat(state?.promo_discount || 0);

                                            const gst = Math.ceil(subtotal * 0.18); // 🔹 Rounded up GST
                                            return `${currencyType2[state?.vendor?.country]?.code} ${gst}`;
                                        })()}
                                    </span>
                                </div>

                                <hr style={{ borderColor: '#fff', margin: '20px 0' }} />

                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        fontFamily: 'Poppins, sans-serif',
                                        color: Colors.secondary
                                    }}
                                >
                                    <Typography className="heading-font" variant="h6" gutterBottom>
                                        Order <Box className="heading-font" component={"span"}> Total :</Box>
                                    </Typography>
                                    <span className="heading-font">
                                        {(() => {
                                            const subtotal =
                                                parseFloat(state?.sub_amount || 0) +
                                                parseFloat(state?.delivery_charges || 0) -
                                                parseFloat(state?.promo_discount || 0);

                                            const gst = Math.ceil(subtotal * 0.18);
                                            const total = Math.ceil(subtotal + gst); // 🔹 Rounded up total
                                            return `${currencyType2[state?.vendor?.country]?.code} ${total}`;
                                        })()}
                                    </span>
                                </div>

                                <hr style={{ borderColor: '#fff', margin: '20px 0' }} />

                            </div>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </div >
    )
}

export default OrderDetail
